import React, { Component } from 'react';
import Axios from 'axios';
import cachios from 'cachios'
import { BASE } from "../api/api";
import { Link } from 'react-router-dom'
import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';
import Header from '../header/newheader';
import Footer from '../footer/newfooter';
import ArchiveDesc from '../events/archivedesc';  //archivedesc
import ArchiveCont from '../events/archivecont';
import TopBar from '../topbar/topbar'
import { List } from 'react-content-loader'
import sample from '../assets/annualreport.png'
import './book.css';
import search from '../assets/search.png'
import pageleft from '../assets/Home/pageleft.png'
import pagenoleft from '../assets/Home/pagenoleft.png'
import pagenoright from '../assets/Home/pagenoright.png'
import pageright from '../assets/Home/pageright.png'
import home from '../assets/Home/home.png'
import crumbarrow from '../assets/Home/right.png'


class Article extends Component {
    constructor(props) {
        super(props);
        this.state = {
            limit: 10,
            offset: localStorage.getItem('pagenum') ? JSON.parse(localStorage.getItem('pagenum')) : 0,
            next: false,
            prev: false,
            tab: 'pub',
            search: '',
            imagearray: [],
            cluster: '',
            project: '',
            objarr: [],
            checkarr: [],
            filter: null
        };
    }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    pagestore(id) {

        localStorage.setItem('pagenum', JSON.stringify(id))

    }
    color(type, value) {
        let dt = this.state.checkarr.indexOf(type + ':' + value)
        if (dt > -1) {
            return true
        }
        else
            return false
    }
    //Next/previous click function
    handlePageClick = data => {
        console.log(data, 'offset')

        if (data === 'next' && this.state.next === true) {
            this.setState({
                thesis: '',
            })
            this.apicall(this.state.offset + this.state.limit, this.state.search)
            this.setState({
                offset: this.state.offset + this.state.limit
            })
            console.log(this.state.offset, 'offset in api')

        }
        else if (data === 'prev' && this.state.prev === true) {
            this.setState({
                thesis: '',
            })
            this.setState({
                offset: this.state.offset - this.state.limit
            })
            this.apicall(this.state.offset - this.state.limit, this.state.search)
        }


    };
    signout() {
        localStorage.removeItem('token');
        localStorage.removeItem('expirytime');
        localStorage.removeItem('expiryref');
        this.props.history.push("/login?redir=/cis_publication")

    }


    refreshexp() {
        let s = new Date();
        s.setSeconds(s.getSeconds() + 1800);
        localStorage.setItem('expiryref', s)
    }


    checkexpiry() {
        if (localStorage.getItem('expiryref')) {
            let expref = Date.parse(localStorage.getItem('expiryref'))
            let s = new Date();
            if (s > expref) {
                // this.fillalert('Session Expired!Logging Out')
                this.signout()
            }
            else {
                this.refreshexp()
            }

        }
        else {
            this.fillalert('Session Expired!Logging Out')
            this.signout()

        }
    }

    //   componentWillMount(){
    //     if(this.state.token)
    //   }
    componentWillMount() {
        this.topFunction()
        localStorage.removeItem('pagenum')
        if (this.props.location.paper) {
            this.setState({ tab: this.props.location.paper.tab })
        }
        let dt = localStorage.getItem('token')
        // if (!dt || dt == null) {
        //     this.props.history.push("/login?redir=/cis_publication")
        // }
        // else {
        //     this.checkexpiry()

        this.setState({ proceed: true })
        //}
        this.setState({

            thesis: undefined
        })

        this.apicall(this.state.offset, this.state.search)
        this.description();
        this.archivefilter();

    }
    description() {
        cachios.get(BASE + 'jsonapi/block_content/basic?include=field_image', {
            ttl: 300 /* seconds */,
        })
            .then((data) => {
                console.log(data.data.data, 'desc')

                this.setState({
                    desc: data.data.data,
                    descimg: data.data.included[0]
                })
            })
            .catch((err) => {
                console.log('not found')
            })
    }
    archivefilter() {
        Axios.get(BASE + 'api/archives_filter_list', {
            ttl: 300 /* seconds */,
        })
            .then((data) => {
                console.log(data.data, 'desc')
                this.setState({
                    mainfilter: data.data.data.organizer,
                    subfilter: data.data.data.event_types
                })

            })
            .catch((err) => {
                console.log('not found')
            })
    }
    setfilter(type, value) {
        let object = {}
        let orgfilter = []
        let evefilter = []
        let checkarr = this.state.checkarr
        object[type] = value
        let objarr = this.state.objarr
        let dt = checkarr.indexOf(type + ':' + value)
        if (dt > -1) {
            checkarr.splice(dt, 1);
            objarr.splice(dt, 1);
        }
        else {
            checkarr.push(type + ':' + value)
            objarr.push(object)
        }
        console.log(object, objarr, 'test')
        this.setState({
            objarr: objarr,
            checkarr: checkarr
        })
        let index = 0
        let filter = []
        if (objarr == [])
            filter = ''
        else {
            objarr.map((object1, ind) => {
                for (var i in object1) {
                    if (orgfilter.indexOf(i) === -1) {
                        orgfilter.push(i) // alerts key
                        filter.push('event[B' + index + ']=organizer:' + i)
                        index++
                    }
                    if (evefilter.indexOf(object1[i]) === -1) {
                        evefilter.push(object1[i]); //alerts key's value
                        filter.push('event[B' + index + ']=event_type:' + object1[i])
                        index++
                    }
                }
            })
        }

        this.setState({
            filter: filter.join('&')
        })
    }
    getHighlightedText(text) {
        // Split on higlight term and include term into parts, ignore case
        if (this.state.search) {
            let parts = text.split(new RegExp(`(${this.state.search})`, 'gi'));
            return <div className="myspan"> {parts.map((part, i) =>
                <span key={i} style={part.toLowerCase() === this.state.search.toLowerCase() ? { backgroundColor: 'yellow', display: 'inline' } : {}}>
                    {part}
                </span>)
            } </div>;
        }
        else {
            return (text)
        }
    }
    offset(e) {
        this.setState({
            offset: 0
        })
    }

    searchclick(id, contains) {
        this.apicall(id, contains)
    }

    apicall(id, contains) {

        this.setState({
            search: contains,
            thesis: ''
        })
        //HIDE/SHOW  previous button
        if (id <= 0) {
            this.setState({
                prev: false,
            })
        }
        else {
            this.setState({
                prev: true
            })
        }

        Axios.get(BASE + 'jsonapi/node/submit_for_work?filter[cis][condition][path]=field_cis_publications&filter[cis][condition][value]=1&filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Books&filter[title][condition][path]=title&filter[title][condition][path]=title&filter[title][condition][operator]=CONTAINS&filter[title][condition][value]=' + contains + '&page[limit]=' + this.state.limit + '&page[offset]=' + (id + this.state.limit) + '&sort=-field_year')
            .then((data) => {
                console.log(data.data, 'next')
                //HIDE/SHOW  NEXT button
                if (data.data.data.length === 0) {
                    this.setState({
                        next: false,
                    })
                }
                else {
                    this.setState({
                        next: true
                    })
                }
            })

        cachios.get(BASE + 'jsonapi/node/submit_for_work?include=field_image&filter[cis][condition][path]=field_cis_publications&filter[cis][condition][value]=1&filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Books&filter[title][condition][path]=title&filter[title][condition][path]=title&filter[title][condition][operator]=CONTAINS&filter[title][condition][value]=' + contains + '&page[limit]=' + this.state.limit + '&page[offset]=' + id + '&sort=-field_year', {
            ttl: 500 /* seconds */,
        })

            .then((datz_thesis) => {

                this.setState({
                    thesis: datz_thesis.data.data,
                    count: datz_thesis.data.meta ? datz_thesis.data.meta.count : 0

                })
                this.topFunction();

                let i, j;
                let imagearray = []
                for (i = 0; i < datz_thesis.data.data.length; i++) {
                    if (datz_thesis.data.data[i].relationships.field_image.data !== null) {
                        for (j = 0; j < datz_thesis.data.included.length; j++) {
                            if (datz_thesis.data.data[i].relationships.field_image.data.id === datz_thesis.data.included[j].id) {
                                imagearray.push(BASE + datz_thesis.data.included[j].attributes.uri.url);
                            }
                        }
                    }
                    else {
                        imagearray.push(sample)
                    }
                }
                this.setState({
                    imagearray: imagearray
                })
                console.log(imagearray)
            })
            .catch(error => console.log(error));

    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    _handleKeyPress(e) {

        if (e.key === 'Enter') {
            this.searchclick(0, this.state.search)
        }
    }

    render() {
        if (this.state.proceed === true)
            return (
                <div className='formrea yourwork sub_work cispub'>
                    <Header />
                    <div className="title-banner" >
                        <div className="heading-one white-text bold">
                            CIS Publications
                        </div>
                    </div>
                    <div className='container'>

                        <div className="listing">
                            <div className='top-contents'>
                                <div className="new-crumbs breadcrumbs gray-text">
                                    <Link className='gray-text' to='/'><img className='crumb-home' src={home} /></Link><img className='rightarrow' src={crumbarrow} />
                                    Research<img className='rightarrow' src={crumbarrow} />
                                    {this.state.tab == 'pub' ?
                                        <Link className='gray-text' onClick={() => this.setState({ tab: 'pub' })} to='/cis_publication'>CIS Publications</Link>
                                        : null}
                                    {this.state.tab === 'paper' ?
                                        <Link className='gray-text' to='/cis_publication'> CIS Working Papers</Link>
                                        : null}
                                    {this.state.tab === 'report' ?
                                        <Link className='gray-text' to='/cis_publication'> CIS Reports</Link>
                                        : null}
                                </div>
                                {/* <TopBar data={'data1'} /> */}
                            </div>

                            <div className="page-title">
                                {/* <div className="title-wrapper">
                                    <div className="gloss_container">
                                        <h1 className="heading">CIS Publications</h1>
                                    </div>
                                </div> */}
                                <div className='rowed' style={{ marginTop: "5%" }}>
                                    <div className='toggle-bar-two'>
                                        <button onClick={() => this.setState({ tab: 'pub' })} className={this.state.tab === "pub" ? "bg-blue white-text" : "bg-blue no-active blue-text"} >CIS Publications</button>
                                        <button onClick={() => this.setState({ tab: 'paper' })} className={this.state.tab === "paper" ? "bg-blue white-text" : "bg-blue no-active blue-text"} >CIS Working Papers</button>
                                        <button onClick={() => this.setState({ tab: 'report' })} className={this.state.tab === "report" ? "bg-blue white-text" : "bg-blue no-active blue-text"} >CIS Reports</button>
                                    </div>
                                    {/* <div className="search_input" style={{ alignSelf: 'center', zIndex: this.state.inputhide == true ? -1 : 0 }}>
                                        <input type="text" placeholder="Search " name="search" onChange={(e) => { this.apicall(this.state.offset, e.target.value); this.offset(e) }} maxLength={16} />
                                        <div className="search_logo" style={{ top: '5px' }} onClick={() => this.apicall(this.state.offset, this.state.search)}><img src={search} height="16px" /></div>
                                    </div> */}
                                    <input id="newSearchInput" className="newSearchInput" type="text" placeholder="Search " name="search" onChange={(e) => { this.apicall(this.state.offset, e.target.value); this.offset(e) }} maxLength={16} />

                                </div>

                            </div>
                            <div className="main-content">
                                <div className="">
                                    <div className="row">
                                        <div className="region region-content">
                                            {this.state.tab === "paper" ?
                                                <div className="listings">

                                                    <h5 style={{ color: 'grey', marginLeft: '7px' }}>Under Construction</h5>

                                                </div>
                                                : null}
                                            {this.state.tab === 'report' ?
                                                <div className='searchpage archive_page project_page'>
                                                    <div className="main-content listing" id="book-report">
                                                        <div className="newsrea" style={{ width: '100%' }}>
                                                            <div className="row">
                                                                <ArchiveDesc />
                                                                <div className="region region-content search_inner_container">
                                                                    <div className="filter_block">
                                                                        <div className="filter_container">
                                                                            <h2 className='heading2 reporthead'>Reports</h2>
                                                                            {this.state.subfilter ?
                                                                                this.state.mainfilter.sort((a, b) => parseFloat(a.field_sort_order) - parseFloat(b.field_sort_order)).map((main, mainind) => {
                                                                                    if (main.organizer_value === 'CIS archives')
                                                                                        return <div className="filter_inner_wrapper">
                                                                                            <div>
                                                                                                <div className="filter_inner_wrpr">

                                                                                                    {this.state.subfilter ? this.state.subfilter.map((val_arr, ind) => {
                                                                                                        if (main.organizer_value === "LSE/SOAS archives" && val_arr.event_type_value === "Forums" && val_arr.event_type_value === "Reports" || (val_arr.event_type_value === "Lectures/Seminars")) {
                                                                                                            return null
                                                                                                        }
                                                                                                        else {
                                                                                                            if (val_arr.event_type_value !== 'Reports')
                                                                                                                return (<div className="selct_container" >
                                                                                                                    <div className="selct_box" style={{ background: this.color(main.organizer_key, val_arr.event_type_key) ? '#165E84' : '' }} onClick={() => this.setfilter(main.organizer_key, val_arr.event_type_key)} ></div>
                                                                                                                    <div className="selct_value" onClick={() => this.setfilter(main.organizer_key, val_arr.event_type_key)} >{main.organizer_value === "CIS archives" && val_arr.event_type_value === "Forums" ? "Conferences" : val_arr.event_type_value}</div>
                                                                                                                </div>)
                                                                                                        }

                                                                                                    }) : ''}
                                                                                                </div>

                                                                                            </div>

                                                                                        </div>
                                                                                })

                                                                                : ''}
                                                                        </div>
                                                                    </div>
                                                                    <div className="search_block">

                                                                        {this.state.filter ? <ArchiveCont filter={this.state.filter} /> : <ArchiveCont filter={'everything'} />}

                                                                    </div>



                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="button-responsive">
                                                        <button onClick={() => this.setState({
                                                            fpopup: !this.state.fpopup
                                                        })} class="filter">Filter</button>
                                                        <i class="filter-icon"></i>
                                                    </div>
                                                    {/* MObile FIlter */}
                                                    <div className='mobile_filter' style={{ display: this.state.fpopup ? '' : 'none' }}>
                                                        <div className='mobile_filter_head' ><div>Filters</div><div onClick={() => this.setState({
                                                            fpopup: !this.state.fpopup
                                                        })}>X</div></div>
                                                        <div className="filter_block">
                                                            <div className="filter_container">

                                                                {this.state.subfilter ?
                                                                    this.state.mainfilter.map((main, mainind) => {
                                                                        return <div className="filter_inner_wrapper">
                                                                            <div>

                                                                                <div className="filter_inner_wrpr">
                                                                                    <Accordion>
                                                                                        <AccordionItem expanded={mainind === 0 ? true : false}>
                                                                                            <AccordionItemTitle className='accordion__title'>
                                                                                                <div className='sub'>
                                                                                                    <div className='card-title'>{main.organizer_value}</div>
                                                                                                    <div class="accordion__arrow" role="presentation"></div>
                                                                                                </div>
                                                                                            </AccordionItemTitle>
                                                                                            <AccordionItemBody>
                                                                                                {this.state.subfilter ? this.state.subfilter.map((val_arr, ind) => {
                                                                                                    return (<div className="selct_container" >
                                                                                                        <div className="selct_box" style={{ background: this.color(main.organizer_key, val_arr.event_type_key) ? '#165E84' : '' }} onClick={() => this.setfilter(main.organizer_key, val_arr.event_type_key)} ></div>
                                                                                                        <div className="selct_value" onClick={() => this.setfilter(main.organizer_key, val_arr.event_type_key)} >{val_arr.event_type_value}</div>
                                                                                                    </div>)
                                                                                                }) : ''}
                                                                                            </AccordionItemBody>
                                                                                        </AccordionItem>
                                                                                    </Accordion>
                                                                                </div>

                                                                            </div>

                                                                        </div>
                                                                    })

                                                                    : ''}


                                                                <div class="button-responsive">
                                                                    <button onClick={() => this.setState({
                                                                        fpopup: !this.state.fpopup
                                                                    })} class="filter">Apply Filter</button>
                                                                    <i class="filter-icon"></i>
                                                                </div>

                                                            </div>



                                                        </div>

                                                    </div>
                                                </div>
                                                : ''
                                            }
                                            {this.state.tab === "pub" ?
                                                <div className="listings">
                                                    {this.state.thesis && this.state.imagearray.length !== 0 ?
                                                        <div className="mission">
                                                            {this.state.thesis.map((inst, index) => {
                                                                let data = index % 2 === 0 ? "left" : ""
                                                                return (
                                                                    <div className="field-content rows" style={{ marginRight: data ? "10%" : "0" }}>
                                                                        <div className="publicationImage">
                                                                            <Link to={{ pathname: '/cis_publication/' + `${inst.attributes.title.replace(/\W+(?!$)/g, '-')}/${inst.attributes.drupal_internal__nid}`, state: { dat_arr: inst.attributes } }}>
                                                                                <img src={this.state.imagearray[index]} />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="publicationDetails">
                                                                            <div className="blue-text pub-title">
                                                                                <Link className="heading-four blue-text bold" to={{ pathname: '/cis_publication/' + `${inst.attributes.title.replace(/\W+(?!$)/g, '-')}/${inst.attributes.drupal_internal__nid}`, state: { dat_arr: inst.attributes } }}>{inst.attributes.title}</Link>
                                                                            </div>
                                                                            <div className="blue-text other-details">
                                                                                Year : {inst.attributes.field_year}
                                                                            </div>
                                                                            {inst.attributes.field_pages ?
                                                                                <div className="blue-text other-details">
                                                                                    Pages : {inst.attributes.field_pages}
                                                                                </div>
                                                                                : null}
                                                                            {inst.attributes.field_isbn && inst.attributes.field_isbn !== "N/A" && inst.attributes.field_isbn !== "n/a" ?
                                                                                <div className="blue-text other-details">
                                                                                    ISBN : {inst.attributes.field_isbn}
                                                                                </div> : ''}

                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                            )}

                                                        </div> : <List />

                                                    }


                                                </div> : null}
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    {this.state.tab === "pub" ? this.state.thesis.length !== 0 ? <div className='new-pagination'>
                        <button disabled={!this.state.prev} onClick={() => this.handlePageClick('prev')} className='prev'>{!this.state.prev ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offset ? (this.state.offset / 10) + 1 : 1}</div><span className='pagination-of bold'> of </span><div className='total'>{this.state.count ? Math.ceil(this.state.count / 10) : 1}</div> <button disabled={!this.state.next} onClick={() => this.handlePageClick('next')} className='next'>{this.state.next ? <img src={pageright} /> : <img src={pagenoright} />}</button>
                    </div> : "" : ""}
                    {/* {this.state.thesis && this.state.tab === "pub" && (this.state.prev || this.state.next) ?

                        <ul className="pagination side-pagination" style={{ paddingBottom: '4%' }} >
                            <li onClick={() => this.handlePageClick('prev')} className="previous disabled">
                                <a style={{ color: this.state.prev ? '#165E84 ' : '', fontWeight: this.state.prev ? '500' : '', cursor: this.state.prev ? '' : 'not-allowed' }} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a></li>
                            <li onClick={() => this.handlePageClick('next')} className="next"><a style={{ color: this.state.next ? '#165E84 ' : '', fontWeight: this.state.next ? '500' : '', cursor: this.state.next ? '' : 'not-allowed' }} tabindex="0" role="button" aria-disabled="false">Next</a></li>
                        </ul>

                        : ''} */}
                    <Footer />
                </div>


            )
        else
            return (
                <div></div>
            )
    }

}

export default Article;